import React, { useEffect, useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import Constants from "../../data/Constants";
import Utils from "../../utils/index";
import { isMobile } from "react-device-detect";
import { Box, Button, Chip } from "@mui/material";
import moment from "moment";
import { getAllOrders } from "../../services/order.service";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import OrderDetailsDialog from "../../components/OrderDetailsDialog";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

const customHeaderStyle = (params) => {
  return <b>{params.colDef.headerName}</b>;
};

function Orders(props) {
  const columns = [
    {
      field: "orderNumber",
      width: 200,
      headerName: "Order Number",
      renderHeader: customHeaderStyle,
    },

    {
      field: "status",
      headerName: "Status",
      renderHeader: customHeaderStyle,
    },

    {
      field: "totalAmount",
      width: 150,
      headerName: "Total Amount (₹)",
      renderHeader: customHeaderStyle,
    },

    {
      field: "discountAmount",
      width: 150,
      headerName: "Discount Amount (₹)",
      renderHeader: customHeaderStyle,
    },

    {
      field: "payableAmount",
      width: 150,
      headerName: "Payable Amount (₹)",
      renderHeader: customHeaderStyle,
    },

    {
      field: "createdBy",
      headerName: "User",
      width: 200,
      renderHeader: customHeaderStyle,
      renderCell: (params) => (
        <Link
          to={"/dashboard/mentees/" + params.value._id}
          className="hover:underline"
        >
          {params.value.firstname
            ? params.value.firstname + " " + params.value.lastname
            : "Unknown"}
        </Link>
      ),
    },

    {
      field: "updatedAt",
      width: 250,
      headerName: "Completed At",
      type: "date",
      renderHeader: customHeaderStyle,
      valueFormatter: (params) =>
        moment(params?.value).format(Constants.DATE_TIME_FORMAT),
    },

    {
      field: "_id",
      width: 250,
      headerName: "Actions",
      renderHeader: customHeaderStyle,
      renderCell: (params) => {
        return (
          <div>
            <Button
              onClick={() => {
                setOrderDialog({
                  status: true,
                  data: params.row,
                });
              }}
            >
              View Order
            </Button>
          </div>
        );
      },
    },
  ];

  const navigate = useNavigate();
  const [data, setData] = useState(false);
  const [orderDialog, setOrderDialog] = useState({
    status: false,
    data: false,
  });
  const { setProgress, setToast, isRefreshed } = useOutletContext();

  useEffect(() => {
    setProgress(true);

    async function api() {
      try {
        const data = await getAllOrders(); // all orders
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error

          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, [isRefreshed]);

  return (
    <div className="flex h-full w-full">
      <div className="w-full overflow-scroll " style={{ height: "85vh" }}>
        <DataGrid
          rows={data ?? []}
          columns={columns}
          getRowId={(row) => row._id}
          autoPageSize
          components={{
            Toolbar: CustomToolbar,
          }}
        />

        <OrderDetailsDialog
          open={orderDialog.status}
          order={orderDialog.data}
          onClose={() => {
            setOrderDialog({ status: false, data: false });
          }}
        />
      </div>
    </div>
  );
}

export default Orders;
